// src/components/ui/Breadcrumbs/Breadcrumbs.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export const Breadcrumbs = ({ items, className = '' }) => {
  return (
    <nav style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '13px',
      color: 'rgb(var(--c-text-secondary))',
      flexWrap: 'wrap',
    }} className={className}>
      <Link to="/" style={{ color: 'rgb(var(--c-text-secondary))', textDecoration: 'none' }}>
        Главная
      </Link>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={index}>
            <span style={{ color: 'rgb(var(--c-text-secondary))' }}>/</span>
            {isLast ? (
              <span style={{ color: 'rgb(var(--c-text))', fontWeight: 500 }}>
                {item.label}
              </span>
            ) : (
              <Link
                to={item.path}
                style={{
                  color: 'rgb(var(--c-text-secondary))',
                  textDecoration: 'none',
                  transition: 'color 0.2s',
                }}
                onMouseEnter={(e) => e.target.style.color = '#1A1A1A'}
                onMouseLeave={(e) => e.target.style.color = '#6B6B6B'}
              >
                {item.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};